<script>
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import { clientService } from "../../../services/authservice/client.service";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Lock screen page -component
 */
export default {
  // extends: Screen,
  page: {
    title: "Client URL",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mounted() {
    const host = window.location.host;
    const parts = host.split('.');

    localStorage.clear();

    //console.log(parts[0], this.client);

    if( parts[0].includes('localhost')) {

      this.checkingLoadURL('dev');
      this.url = 'dev';

    } else if(parts[0] != 'www' && parts[0] != '') {

      this.checkingLoadURL(parts[0]);
      this.url = parts[0];

    }
  },

  data() {
    return {
      url: '',
      client: null,
      tryingToSubmit: false,
      fetchingStats: false,
      isChecked: false,
    }
  },
  components: { 
    Button,
    Input
  },
  methods: {

    checkingURL: function() {
      this.fetchingStats = false;
      this.tryingToSubmit = true;

      clientService.getCode(this.url)
        .then(response => {

          this.fetchingStats = true;
          this.tryingToSubmit = false;

          if(response.data != null) {
            this.client = response.data;
            window.location = `http://${this.client.url}.propnavigation.com/client`;
            
          } else {
            // console.log(response);

            this.$swal.fire({
              title: i18n.t('general.client'),
              text: i18n.t('general.client-not-found'),
              icon: "warning",
              confirmButtonText: i18n.t('general.ok')
            }).then(result => {
              if (result.value) {
                this.url = "";
              }
            });

          }

        });
    },

    checkingLoadURL: function(url) {
      this.fetchingStats = false;
      this.tryingToSubmit = true;

      clientService.getCode(url)
        .then(response => {

          this.fetchingStats = true;
          this.tryingToSubmit = false;
          
          if(response.data != null) {

            localStorage.client = JSON.stringify(response.data);
            localStorage.locale = "km";

            this.$router.push(this.$route.query.redirectFrom || {
                name: "login",
            });
          } 

        });
    },

    

  },
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <router-link tag="a" to="/" class="text-dark">
        <i class="mdi mdi-home-variant h2"></i>
      </router-link>
    </div>
    <div class="account-pages my-5 pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
              <div class="bg-soft bg-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">{{$t('general.client')}}</h5>
                      <p>{{$t('general.client-desc')}}</p>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img
                      src="@/assets/images/profile-img.png"
                      alt
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div>
                  <a href="/">
                    <div class="avatar-md profile-user-wid mb-4">
                      <span class="avatar-title rounded-circle bg-light" style="background-color: #ecc952 !important;">
                        <img
                          src="@/assets/images/logo.svg"
                          alt
                          class="rounded-circle"
                          height="34"
                        />
                      </span>
                    </div>
                  </a>
                </div>
                <div class="p-2">
                  <form class="form-horizontal">
                    <div class="mb-3">
                      <Input 
                        :type="text"
                        :id="'url'"
                        :label="'general.client'"
                        v-model="url"
                        :last="'general.pn'" />
                    </div>

                    <div class="row mb-0">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="checkingURL()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.submit')"  />
                    </div>
                  
                  </form>
                </div>
              </div>
            </div>
            <div class="mt-5 text-center">
              <p>
                © {{ new Date().getFullYear() }} Properties Navigation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
